module.exports = __webpack_public_path__ + "img/Icon_marketplace.762484b3.svg";